export const SETTINGS_CONFIG = {
    store: {
        SAFETY_STATUS_CHECK: {
            label: "Safety Status Check",
            propertyName:"isSafetyStatusCheckEnabled",
            tablePropertyName: "safety_check_flag"
        },
        EMAIL_REPORT: {
            label: "Email Report",
            propertyName:"isSalesForceEmailEnabled",
            tablePropertyName: "email_sfmc_flag"
        },
        SERVICE_HISTORY: {
            label: "Service History",
            propertyName: "isServiceHistoryEnabled",
            tablePropertyName: "service_history_flag"
        },
        PREVIOUS_INSPECTION_VIEW: {
            label: "Previous Inspection View",
            propertyName: "isPreviousInspectionViewEnabled",
            tablePropertyName: "safety_check_previous_inspection_view_flag"
        },
        EMAIL_PRIORITY: {
            label: "Email Priority",
            propertyName: "isEmailPriorityEnabled",
            tablePropertyName: "email_priority_send_flag"
        },
        STATUS_INSPECTION: {
            label: "Inspection Status",
            propertyName: "isStatusInspectionEnabled",
            tablePropertyName: "wo_status_feature_flag"
        }
    },
    global: {
        INGEST_PRODUCT_EXCLUSION : {
            label: "Ingest Product Exclusion",
        },
        LICENSE_PLATE_EXCLUSION : {
            label: "Excluded License Plates",
        }
    }
};